import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'react-toastify';

export const ForecastPlanningSystemEditModal = ({
    isOpen,
    onClose,
    labelItem,
    noteItem,
    onAccept
}) => {
    const [name, setName] = useState(labelItem || '');
    const [note, setNote] = useState(noteItem || '');

    useEffect(() => {
        if (!isOpen) return;
        if (labelItem) {
            setName(labelItem);
        }
        if (noteItem) {
            setNote(noteItem);
        }
    }, [isOpen]);

    const handleAcceptActions = async () => {
        if (!name) {
            toast.error(`Empty forecast planning options.`, { position: "bottom-right" });
            return;
        }
        await onAccept({
            name: name,
            note: note,
        });
    }

    const handleClose = () => {
        onClose();
        setName('');
        setNote('');
    };

    // Handle Esc key press
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
                handleClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscKey);
        }
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const modalContent = (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div 
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" 
                    aria-hidden="true"
                    onClick={handleClose}
                ></div>
                <span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">&#8203;</span>
                <div 
                    className="inline-block transform rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:align-middle"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <h3 className="text-lg font-bold mb-2">Forecast Planning</h3>
                        <div className="flex flex-col gap-1 mb-2">
                            <span>Name:</span>
                            <div className="flex-1">
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => {
                                        setName(e.target.value)
                                    }}
                                    className="w-full p-2.5 shadow-sm border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                         </div>
                        <div className="flex flex-col gap-1 mb-2">
                            <span>Note:</span>
                            <div className="flex-1">
                                <textarea
                                    value={note}
                                    onChange={(e) => {
                                        setNote(e.target.value)
                                    }}
                                    className="mt-1 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 outline-none min-h-[150px]"   
                                />
                            </div>
                         </div>
                         <div className="py-3 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                    onClick={handleAcceptActions}
                                >
                                    Accept
                                </button>
                                <button
                                    type="button"
                                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return createPortal(modalContent, document.body);
};